import type { TrackingIntegration, TrackingIntegrationStatus } from '@chukua/common';

export const STATUS_LABELS: Record<TrackingIntegrationStatus, string> = { enabled: 'Enabled', disabled: 'Disabled', uninstalled: 'Uninstalled' };
export const STATUS_TAG_COLORS: Record<TrackingIntegrationStatus, string> = { enabled: 'success', disabled: 'default', uninstalled: 'error' };

/** The line under an installation's status: when it was last tested and whether that passed. */
export function lastTestSummary(integration: Pick<TrackingIntegration, 'lastTestOk' | 'lastTestReason' | 'lastTestedAt'>): string {
  if (!integration.lastTestedAt) return 'Never tested';
  const when = new Date(integration.lastTestedAt).toLocaleString();
  return integration.lastTestOk ? `Connected ${when}` : `Failed ${when}: ${integration.lastTestReason ?? 'no reason given'}`;
}
